import { EPermissoes } from '@/enums/ePermissoes';
import cadastro from './cadastro/routes';
import relatorios from './relatorios/routes';

export default [
  {
    description: '1. Programação de Concretagem',
    path: 'programacao',
    name: 'programacaoconcretagem',
    component: () => import('@/views/concreto/concretagem/components/GridProgramacaoIndex.vue'),
    goesToMenu: true,
    meta: {
      programacao: true,
      utlTipoFornecimentoId: 1,
      permissions: [EPermissoes.Lancamento_Programacao],
      escopoObra: 'obra'
    }
  },
  {
    description: 'Múltiplas Programações de Concretagem',
    path: 'programacao/multiplas',
    name: 'programacaoconcretagemmultiplas',
    component: () => import('@/views/concreto/concretagem/MultiplasProgramacoes.vue'),
    meta: {
      parentRouteName: 'programacaoconcretagem',
      programacao: true,
      utlTipoFornecimentoId: 1,
      permissions: [EPermissoes.Lancamento_Programacao],
      grupos: []
    }
  },
  {
    description: 'Inclusão de Programação de Concretagem',
    path: 'programacao/incluir',
    name: 'programacaoconcretageminsert',
    component: () => import('@/views/concreto/concretagem/InclusaoEdicao.vue'),
    meta: {
      parentRouteName: 'programacaoconcretagem',
      programacao: true,
      utlTipoFornecimentoId: 1,
      permissions: [EPermissoes.Lancamento_Programacao],
      grupos: []
    }
  },
  {
    description: 'Edição de Programação de Concretagem',
    path: 'programacao/editar/:id',
    name: 'programacaoconcretagemupdate',
    component: () => import('@/views/concreto/concretagem/InclusaoEdicao.vue'),
    meta: {
      parentRouteName: 'programacaoconcretagem',
      programacao: true,
      utlTipoFornecimentoId: 1,
      permissions: [EPermissoes.Lancamento_Programacao],
      grupos: []
    }
  },
  {
    description: '2. Concretagem',
    path: 'concretagem',
    name: 'concretagem',
    component: () => import('@/views/concreto/concretagem/Index.vue'),
    goesToMenu: true,
    meta: {
      utlTipoFornecimentoId: 1,
      permissions: [EPermissoes.Lancamento_Concretagem],
      escopoObra: 'obra'
    }
  },
  {
    description: 'Inclusão de Concretagem',
    path: 'concretagem/incluir',
    name: 'concretageminsert',
    component: () => import('@/views/concreto/concretagem/InclusaoEdicao.vue'),
    meta: {
      parentRouteName: 'concretagem',
      utlTipoFornecimentoId: 1,
      permissions: [EPermissoes.Lancamento_Concretagem],
      grupos: []
    }
  },
  {
    description: 'Edição de Concretagem',
    path: 'concretagem/editar/:id',
    name: 'concretagemupdate',
    component: () => import('@/views/concreto/concretagem/InclusaoEdicao.vue'),
    meta: {
      parentRouteName: 'concretagem',
      utlTipoFornecimentoId: 1,
      permissions: [EPermissoes.Lancamento_Concretagem],
      grupos: []
    }
  },
  {
    description: '3. Resultado de Ensaios',
    path: 'cadastro/ensaio',
    name: 'ensaioconcreto',
    component: () => import('@/views/utilidade/ensaio/Index.vue'),
    goesToMenu: true,
    meta: {
      utlTipoFornecimentoId: 1,
      permissions: [EPermissoes.Lancamento_ResultadoEnsaios],
      escopoObra: 'obra'
    }
  },
  {
    description: 'Inclusão/Edição de Ensaio de Concreto',
    path: 'cadastro/ensaio/incluir',
    name: 'InclusaoEdicaoEnsaioConcreto',
    component: () => import('@/views/utilidade/ensaio/InclusaoEdicao.vue'),
    goesToMenu: false,
    meta: {
      parentRouteName: 'ensaioconcreto',
      utlTipoFornecimentoId: 1,
      permissions: [EPermissoes.Lancamento_ResultadoEnsaios]
    }
  },
  {
    description: '4. Laudo de Concreto',
    path: 'laudo-concreto',
    name: 'laudoConcreto',
    component: () => import('@/views/controle-tecnologico/laudo/Index.vue'),
    goesToMenu: true,
    meta: {
      tipoFornecimento: 'Concreto',
      utlTipoFornecimentoId: 1,
      permissions: [EPermissoes.Lancamento_Laudo],
      escopoObra: 'obra'
    }
  },
  {
    description: 'Inclusão de Laudo Concreto',
    path: 'laudo-concreto/incluir/:tipoEnsaioId/:laboratorioId',
    name: 'laudoinsertConcreto',
    component: () => import('@/views/controle-tecnologico/laudo/InclusaoEdicao.vue'),
    meta: {
      parentRouteName: 'laudoConcreto',
      utlTipoFornecimentoId: 1,
      laudoOpcional: false,
      permissions: [EPermissoes.Lancamento_Laudo]
    }
  },
  {
    description: 'Edição de Laudo Concreto',
    path: 'laudo-concreto/editar/:id/:tipoEnsaioId/:laboratorioId',
    name: 'laudoUpdateConcreto',
    component: () => import('@/views/controle-tecnologico/laudo/InclusaoEdicao.vue'),
    meta: {
      parentRouteName: 'laudoConcreto',
      utlTipoFornecimentoId: 1,
      laudoOpcional: false,
      permissions: [EPermissoes.Lancamento_Laudo]
    }
  },
  {
    description: '5. Aprovação de Laudo de Concreto',
    path: 'revisao-laudo',
    name: 'revisaoLaudoConcreto',
    component: () => import('@/views/controle-tecnologico/aprovacao-laudo/Index.vue'),
    goesToMenu: true,
    meta: {
      utlTipoFornecimentoId: 1,
      permissions: [EPermissoes.Aprovacao_Laudo],
      escopoObra: 'obra'
    }
  },
  {
    description: 'Portal da Usina',
    path: 'portal-usina',
    name: 'portalusina',
    component: () => import('@/views/concreto/portal-usina/Index.vue'),
    goesToMenu: true,
    meta: {
      programacao: true,
      utlTipoFornecimentoId: 1,
      permissions: [EPermissoes.Portal_Usina]
    }
  },
  {
    description: 'Auditoria de Concretagem',
    path: 'auditoria/concretagem',
    name: 'auditoriaconcretagem',
    component: () => import('@/views/concreto/concretagem/components/GridAuditoriaIndex.vue'),
    goesToMenu: true,
    meta: {
      auditoria: true,
      aprovacao: false,
      utlTipoFornecimentoId: 1,
      permissions: [EPermissoes.Lancamento_Concretagem],
      escopoObra: 'obra'
    }
  },
  {
    description: 'Aprovação de Concretagem',
    path: 'avaliacao/concretagem',
    name: 'avaliacaoconcretagem',
    component: () => import('@/views/concreto/concretagem/components/GridAuditoriaIndex.vue'),
    goesToMenu: true,
    meta: {
      aprovacao: true,
      auditoria: false,
      utlTipoFornecimentoId: 1,
      permissions: [EPermissoes.Aprovacao_Concretagem],
      escopoObra: 'obra'
    }
  },
  {
    description: 'Traço Experimental',
    path: 'traco-experimental',
    name: 'tracoExperimentalConcreto',
    component: () => import('@/views/concreto/traco-experimental/Index.vue'),
    goesToMenu: true,
    meta: {
      utlTipoFornecimentoId: 1,
      tipoConcreto: 1,
      permissions: [EPermissoes.Lancamento_Recebimento],
      escopoObra: 'obra'
    }
  },
  {
    description: 'Inclusão de Traço Experimental de Concreto',
    path: 'traco-experimental/incluir',
    name: 'tracoExperimentalConcretoinsert',
    component: () => import('@/views/concreto/traco-experimental/InclusaoEdicao.vue'),
    goesToMenu: false,
    meta: { parentRouteName: 'tracoExperimentalConcreto', utlTipoFornecimentoId: 1, tipoConcreto: 1, permissions: [EPermissoes.Lancamento_Recebimento] }
  },
  {
    description: 'Edição de Traço Experimental de Concreto',
    path: 'traco-experimental/editar/:id',
    name: 'tracoExperimentalConcretoupdate',
    component: () => import('@/views/concreto/traco-experimental/InclusaoEdicao.vue'),
    goesToMenu: false,
    meta: { parentRouteName: 'tracoExperimentalConcreto', utlTipoFornecimentoId: 1, tipoConcreto: 1, permissions: [EPermissoes.Lancamento_Recebimento] }
  },
  {
    path: 'cadastro',
    description: 'Cadastro',
    goesToMenu: false,
    children: cadastro
  },
  {
    path: 'relatorios',
    description: 'Relatórios',
    goesToMenu: false,
    children: relatorios
  }
];
